const initialFilters = initialSearchFiltersFactory()

export const useSearchFiltersCount = (form: Ref) => {
  const { filters } = storeToRefs(useSearchStore())
  return computed(() => {
    return Object.keys(form.value).reduce((acc, cur) => {
      if ((filters.value as Record<string, any>)[cur] !== (initialFilters as Record<string, any>)[cur]) {
        acc++
      }
      return acc
    }, 0)
  })
}
